var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.4995V9.69685C16.5 6.58759 14.9137 5.14085 12.7987 5.14085C11.092 5.14085 10.327 6.12316 9.90094 6.81269V5.3787H6.68531C6.72797 6.32865 6.68531 15.4995 6.68531 15.4995H9.90094V9.84741C9.90094 9.54581 9.92156 9.24322 10.0069 9.02743C10.2389 8.42274 10.7681 7.79697 11.6559 7.79697C12.8198 7.79697 13.2848 8.72484 13.2848 10.0853V15.5H16.5V15.4995ZM3.29766 3.99719C4.41844 3.99719 5.11734 3.21938 5.11734 2.24786C5.09672 1.25525 4.41891 0.5 3.31922 0.5C2.21953 0.5 1.5 1.25476 1.5 2.24786C1.5 3.21938 2.19797 3.99719 3.2775 3.99719H3.29766ZM4.90547 15.4995V5.3787H1.69031V15.4995H4.90547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9cc47b95c9648d890248c6bf0f2154e8.svg";
export { ForwardRef as ReactComponent };